function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import DownloadWithCircle from 'svg/download-with-circle.svg';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../../components/DownloadDataModal/DownloadDataModal.pcss';
import { isDownloaderUpdated } from '../../selectors';
const useIsDownloaderAppCloseNeeded = ()=>{
    const status = useSelector(selectors.status);
    return status === constants.DOWNLOADER_STATUSES.UPDATE_ENDPOINT_NOT_FOUND;
};
const appName = /*#__PURE__*/ _jsx("b", {
    children: constants.DOWNLOADER_TRAY_APP_NAME
});
const b = (chunk)=>/*#__PURE__*/ _jsx("b", {
        children: chunk
    });
const CloseAppInfo = ()=>{
    const isDownloaderAppCloseNeeded = useIsDownloaderAppCloseNeeded();
    if (!isDownloaderAppCloseNeeded) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.downloader_outdated__close_app_info,
        children: [
            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.downloaderOutdated.closeAppInfo), {
                values: {
                    appName
                }
            })),
            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.downloaderOutdated.clickUpdateNow), {
                values: {
                    b
                }
            }))
        ]
    });
};
const Image = ()=>{
    const isDownloaderAppCloseNeeded = useIsDownloaderAppCloseNeeded();
    if (isDownloaderAppCloseNeeded) {
        return /*#__PURE__*/ _jsx("img", {
            src: "/assets/img/close_downloader_tray.png",
            alt: "Close Downloader tray"
        });
    }
    return /*#__PURE__*/ _jsx(DownloadWithCircle, {
        className: styles.downloader_outdated__loader_icon
    });
};
const Actions = ({ onSetComponent })=>{
    const isDownloaderAppCloseNeeded = useIsDownloaderAppCloseNeeded();
    const updateDownloader = useAction(actions.updateDownloader);
    const onUpdate = ()=>{
        if (isDownloaderAppCloseNeeded) {
            onSetComponent('Initializing');
            return;
        }
        updateDownloader();
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "modal__actions row",
        children: /*#__PURE__*/ _jsx(Button, {
            type: "button",
            styleModifier: "primary",
            labelMessage: messages.buttons.updateNow,
            className: "btn--block btn--filled",
            onClick: onUpdate
        })
    });
};
const DownloaderOutdated = ({ onSetComponent, onSetHeaderMessage })=>{
    const status = useSelector(selectors.status);
    const logEvent = useAction(actions.logEvent, 'UpgradePromptDisplayed');
    const isUpdated = useSelector(isDownloaderUpdated);
    const isUpdating = useSelector(selectors.isUpdatingSelector);
    useEffect(()=>{
        onSetHeaderMessage(messages.addPatient.downloaderOutdated);
        logEvent();
        return ()=>onSetHeaderMessage();
    }, []);
    useEffect(()=>{
        if (isUpdated) {
            onSetComponent('Initializing');
        }
    }, [
        isUpdated
    ]);
    useEffect(()=>{
        if (status === constants.DOWNLOADER_STATUSES.UPDATE_ERROR) {
            onSetComponent('Initializing');
        }
        if (status === constants.DOWNLOADER_STATUSES.UPDATE_BAD_REQUEST_ERROR) {
            onSetComponent('UpdateError');
        }
    }, [
        status
    ]);
    if (isUpdating) {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.modal__content,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.illustration,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/assets/svg/loader.svg",
                        className: "rotatingLoader",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "modal__info text--center mb-5",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.initializing.waiting))
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.downloader_outdated,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "brand__paragraph",
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.downloaderOutdated.info), {
                            values: {
                                appName: /*#__PURE__*/ _jsx("b", {
                                    children: constants.DOWNLOADER_APP_NAME
                                })
                            }
                        })),
                        /*#__PURE__*/ _jsx(CloseAppInfo, {})
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.downloader_outdated__img,
                children: /*#__PURE__*/ _jsx(Image, {})
            }),
            /*#__PURE__*/ _jsx(Actions, {
                onSetComponent: onSetComponent
            })
        ]
    });
};
export default DownloaderOutdated;
